module.exports = __webpack_public_path__ + "img/MAMAKIKE-SELE.94546c82.jpg";